import { useParams, Link, useNavigate } from 'react-router-dom';
import './WikiItemDetail.css';
import './WikiSetDetail.css';
import { FadeIn, StaggerContainer, StaggerItem } from '../components/Animations';
import { McIcon } from '../components/CraftingGrid';

const VIDEO = "https://pub-332780ae20b540038a9ea772f1bf747c.r2.dev/background_vids/vid_1.mp4";

const rarityColors = {
  common: '#9e9e9e',
  uncommon: '#52c078',
  rare: '#5a9ee0',
  epic: '#a070e0',
  legendary: '#f0ab20',
  boss: '#e84c3d',
};

export default function WikiSetDetail({ sets = [], items = [] }) {
  const { slug } = useParams();
  const navigate = useNavigate();

  const set = sets.find(s => s.slug === slug);

  if (!set) {
    return (
      <div className="container" style={{ padding: '4rem 2rem', textAlign: 'center' }}>
        <h2>Set not found</h2>
        <Link to="/wiki" className="btn btn-secondary" style={{ marginTop: '1rem' }}>Back to Wiki</Link>
      </div>
    );
  }

  const setColor = set.color || 'var(--teal)';
  const setItems = set.items || [];

  return (
    <div className="wiki-detail-root">
      <div className="wiki-detail-hero" style={{ '--set-color': setColor }}>
        <video className="wiki-detail-hero-vid" src={VIDEO} autoPlay muted loop playsInline />
        <div className="wiki-detail-hero-overlay" />
        <div className="wsd-hero-color-bar" style={{ background: setColor }} />
        <FadeIn className="wiki-detail-hero-content container" y={30} duration={0.8}>
          <button className="wiki-back-btn" onClick={() => navigate(-1)}>← Back</button>
          <div className="wiki-detail-title-section">
            <div className="wiki-detail-icon-box wsd-icon-box" style={{ borderColor: setColor + '55', boxShadow: `0 0 24px ${setColor}33` }}>
              {set.icon
                ? <McIcon materialKey={set.icon} size={48} />
                : <span style={{ fontSize: '2rem', color: setColor }}>◈</span>
              }
            </div>
            <div>
              <h1 className="wiki-detail-item-name" style={{ color: setColor }}>{set.name}</h1>
              <div className="wiki-detail-item-type" style={{ color: setColor + 'bb' }}>
                Armor / Weapon Set · {setItems.length} {setItems.length === 1 ? 'item' : 'items'}
              </div>
            </div>
          </div>
        </FadeIn>
      </div>

      <StaggerContainer className="container">
        {set.description && (
          <StaggerItem>
            <div className="wsd-description">{set.description}</div>
          </StaggerItem>
        )}

        <StaggerItem>
          <span className="wiki-detail-label">Set Items</span>
          {setItems.length === 0 ? (
            <div className="wsd-empty">No items have been added to this set yet.</div>
          ) : (
            <div className="wsd-item-grid">
              {setItems.map(si => {
                const full = items.find(it => String(it.id) === String(si.id));
                const rarity = si.rarity || full?.rarity || 'common';
                return (
                  <Link key={si.id} to={`/wiki/item/${si.slug}`} className="wsd-item-card">
                    <div className="wsd-item-card-icon" style={{ borderColor: setColor + '44' }}>
                      <McIcon materialKey={si.material || 'barrier'} size={40} />
                    </div>
                    <div className="wsd-item-card-info">
                      <span className="wsd-item-card-name">{si.name}</span>
                      <span className="wsd-item-card-meta" style={{ color: rarityColors[rarity] || '#9e9e9e' }}>
                        {rarity} {si.category || ''}
                      </span>
                    </div>
                    <span className="wsd-item-card-arrow">→</span>
                  </Link>
                );
              })}
            </div>
          )}
        </StaggerItem>
      </StaggerContainer>
    </div>
  );
}
